<template>

    <div class="progress-monitor">
        <tool-container>
            <template v-slot:tabs>
                <b-tab title="Compose">
                    <tool-container-compose-toolbar>
                    </tool-container-compose-toolbar>

                    <progress-monitor-step1 v-if="onStep(1)">
                    </progress-monitor-step1>

                    <progress-monitor-step2 v-if="onStep(2)">
                    </progress-monitor-step2>

                    <progress-monitor-step3 v-if="onStep(3)">
                    </progress-monitor-step3>

                    <progress-monitor-step4 v-if="onStep(4)">
                    </progress-monitor-step4>

                    <progress-monitor-step5 v-if="onStep(5)">
                    </progress-monitor-step5>
                </b-tab>

                <b-tab title="Preview">
                    <tool-container-preview-toolbar>
                    </tool-container-preview-toolbar>

                    <progress-monitor-preview>
                    </progress-monitor-preview>
                </b-tab>
            </template>
        </tool-container>
    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ProgressMonitorMixin from "@/providers/ProgressMonitorMixin";

    export default Vue.extend({
        name: "ProgressMonitor",
        mixins: [ToolMixin, ProgressMonitorMixin],
    })

    /*

        // --------- data storage ------------

        this.onDataLoading = function(data) {
            // convert saved dates from strings to Date objects, to allow binding by date inputs
            if (data.todayDate) {
                data.todayDate = new Date(data.todayDate);
            }
            if (data.startDate) {
                data.startDate = new Date(data.startDate);
            }
            if (data.endDate) {
                data.endDate = new Date(data.endDate);
            }
        }

        this.onDataLoaded = function(data) {
            updateChart(data);
        }

        this.onDataCleared = function(data) {
            updateChart(data);
        }


        // ------- collection methods for step 2 --------

        // clear format on step 2
        this.collectionMethodSelected = function(method) {
            var data = self.ui.getData();
            data.formatMin = method.formats[0].min;
            data.formatMax = method.formats[0].max;
            data.formatTitle = method.formats[0].title;
            self.ui.save(self);
        };

    }
});

     */

</script>

<style lang="scss">

    // not used
    .boilerplate-slot {
        font-weight: bold;
        background-color: #c73865;
        padding: 2px 5px;
        margin: 0 3px 5px 3px;
        display: inline-block;
        color: #fff;
    }

    .progress-monitor-preview .boilerplate-slot {
        color: #333;
        background-color: transparent;
        padding: 0;
        margin: 0;
    }

</style>

